import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  wrap: {
    padding: 8,
    width: 620,
  },

  storyPlaceholder: {
    width: 560,
    height: 186,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 24,
  },
}));

export default useStyles;
